import React from "react";
import { BrowserRouter, Navigate, Routes, Route, useParams, useSearchParams } from "react-router-dom";
import Docs from "./Docs/Docs";
import IteDocs from "./ite/Docs";
import IteLayout from "./ite/Layout";
import IteView from "./ite/View";
import Layout from "./Layout";
import Login from "./Login";
import Logout from "./Logout";
import PubLayout from "./pub/Layout";
import PubView from "./pub/View";
import View from "./View/View";
import Attributes from "./Settings/Attributes";
import DocTypes from "./Settings/DocTypes";
import { CompanyContacts } from "./Settings/CompanyContacts";
import Verify from "./Verify";
import AccountSettings from "./Settings/AccountSettings";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/ite/documents" element={React.createElement(() => {   
            const [searchParams] = useSearchParams();
            return (
              <Navigate to={`/sys/documents/?${searchParams.toString()}`} replace />
              );
        })} />

        <Route path="/ite/documents/:id/view" element={React.createElement(() => {   
            const params = useParams();
            const [searchParams] = useSearchParams();
            return (
                <Navigate to={`/sys/documents/${params.id}/view?${searchParams.toString()}`} replace />
            );
        })} />
        <Route path="/sys/" element={<IteLayout />}>
          <Route path="documents" element={<IteDocs />} />
          <Route path="documents/:id/view" element={<IteView />} />
        </Route>
        <Route path="/pub/" element={<PubLayout />}>
          <Route path="documents/:id/view" element={<PubView />} />
        </Route>
        <Route path="/" element={<Layout />}>
          <Route path="" element={<Navigate to="/documents/all" />} />
          <Route path="documents" element={<Navigate to="/documents/all" />} />
          <Route path="documents/contacts" element={<CompanyContacts />} />
          <Route path="documents/:type?" element={<Docs />} />
          <Route path="documents/:id/view" element={<View />} />
        </Route>
        <Route path="/settings/" element={<Layout />}>
          <Route path="" element={<Navigate to="/settings/attributes" />} />
          <Route path="/settings/attributes" element={<Attributes />} />
          <Route path="/settings/document-type" element={<DocTypes />} />
          <Route path="/settings/account" element={<AccountSettings />} />
        </Route>

      </Routes>
    </BrowserRouter>
  );
}
